import React, { useCallback, useEffect, useState } from "react";
import useViewport from "../../hooks/useViewport";
import { useForm } from "react-hook-form";
import { Main } from "./style";
import { View } from "react-native";
import { useGetUserInfo, useUpdatedUserInfo } from "../../api/MyAccount";
import { getAuth } from "firebase/auth";
import { updateProfile } from "firebase/auth";
import { useCustomTheme } from '../../contexts/useCustomTheme';
import {
  useUpdatedCustomizationInfo,
} from '../../api/Brand';
import Toast from "react-native-toast-message";

export const useMyAccount = () => {
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [termsOfUseUrl, setTermsOfUseUrl] = useState('');
  const [rtmpEmail, setRtmpEmail] = useState('');

  const [webUrl, setWebUrl] = useState('');
  const [salesPageUrl, setSalesPageUrl] = useState('');
  const [iosUrl, setIosUrl] = useState('');
  const [androidUrl, setAndroidUrl] = useState('');
  const [formEmbed, setFormEmbed] = useState('');
  const [myStoreUrl, setMyStoreUrl] = useState('');
  const [hasMyStore, setHasMyStore] = useState(false);

  const auth = getAuth();
  const user = auth.currentUser;
  const { data: dataUserInfo, isLoading: isLoadingUserInfo } = useGetUserInfo(user.uid);

  const {
    customInfo: customizationInfo,
  } = useCustomTheme();

  const {
    mutateAsync: updatedUserInfo,
    isPending: isPendingUpdatedUserInfo,
  } = useUpdatedUserInfo(dataUserInfo && dataUserInfo.id);

  const {
    mutateAsync: updatedCustomInfo,
    isPending: isSavingCustomInfo,
  } = useUpdatedCustomizationInfo();

  const isUrlValid = (url) => {
    try {
      new URL(url);
      return true;
    } catch (error) {
      return false;
    }
  };

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  //UPDATE INFOS
  useEffect(() => {
    if (customizationInfo) {
      setTermsOfUseUrl(customizationInfo.termsOfUseUrl);
      setSalesPageUrl(customizationInfo.salesPageUrl);
      setWebUrl(customizationInfo.webUrl);
      setIosUrl(customizationInfo.iosUrl);
      setAndroidUrl(customizationInfo.androidUrl);
      setFormEmbed(customizationInfo.formEmbed);
      setMyStoreUrl(customizationInfo.myStoreUrl);
      setHasMyStore(customizationInfo.hasMyStore);
      setRtmpEmail(customizationInfo?.rtmpEmail);
    }
  }, [customizationInfo]);


  useEffect(() => {
    setValue("Email", user.email);
    if (dataUserInfo) {
      setValue("Nome_Completo", user.displayName || "");

      setValue("appInformation.IOSUrl", dataUserInfo.appInformation?.IOSUrl || "");
      setValue("appInformation.androidUrl", dataUserInfo.appInformation?.androidUrl || "");
      setValue("appInformation.appName", dataUserInfo.appInformation?.appName || "");
      setValue("appInformation.webUrl", dataUserInfo.appInformation?.webUrl || "");
      // Adicionando "/Login" ao final de webUrl
      const webUrl = dataUserInfo.appInformation?.webUrl || "";
      setValue("appInformation.loginUrl", webUrl ? `${webUrl}/Login` : "");
      setValue("appInformation.supportContact", dataUserInfo.appInformation?.supportContact || "");

      setValue("hasAppInfo", true);
    }
  }, [dataUserInfo, setValue]);

  const onSubmit = useCallback(async (data) => {
    const newData = { ...data };
    // O e-mail de boas-vindas dos alunos usa `appInformation.loginUrl`. Antes,
    // loginUrl só era derivado do webUrl JÁ SALVO (no useEffect de load) e nunca
    // recalculado ao editar o domínio — então o domínio novo preenchido em
    // "Minha conta" não chegava no e-mail. Recalcula sempre a partir do domínio
    // atual do formulário (removendo barra final para não virar `dominio//Login`).
    if (newData.appInformation) {
      const domain = String(newData.appInformation.webUrl || "").trim().replace(/\/+$/, "");
      newData.appInformation = {
        ...newData.appInformation,
        webUrl: domain,
        loginUrl: domain ? `${domain}/Login` : "",
      };
    }
    const updatedData = {
      ...newData,
    };
    await updateProfile(user, { displayName: getValues("Nome_Completo") });
    await updatedUserInfo(updatedData);
    const customizationData = {
      termsOfUseUrl,
      webUrl,
      salesPageUrl,
      iosUrl,
      androidUrl,
      formEmbed,
      myStoreUrl,
      hasMyStore,
      rtmpEmail,
    };
    // filtra undefined pra não mandar campo vazio
    const filtered = Object.fromEntries(
      Object.entries(customizationData).filter(([, v]) => v !== undefined)
    );

    await updatedCustomInfo(filtered);

    Toast.show({ type: "success", text1: "Salvo com sucesso!" });
  },
  [
    user,
    getValues,
    updatedUserInfo,
    updatedCustomInfo,
    termsOfUseUrl,
    webUrl,
    salesPageUrl,
    iosUrl,
    androidUrl,
    formEmbed,
    myStoreUrl,
    hasMyStore,
    rtmpEmail,
  ]
);

  const MobileOrDesktopForm = useCallback(({ children }) => {
    const { width } = useViewport();
    const breakpoint = 1250;
    return width < breakpoint ? (
      <Main style={{ flexDirection: "column", alignItems: "center" }}>
        {children}
      </Main>
    ) : (
      <Main style={{ flexDirection: "row", alignItems: "flex-start" }}>
        {children}
      </Main>
    );
  }, []);

  const MobileOrDesktopContainer = useCallback(({ children }) => {
    const { width } = useViewport();
    const breakpoint = 1250;
    return width < breakpoint ? (
      <View
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {children}
      </View>
    ) : (
      <View
        style={{
          height: "92vh",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {children}
      </View>
    );
  }, []);


  return {
    MobileOrDesktopForm,
    onSubmit,
    control,
    errors,
    handleSubmit,
    isLoadingUserInfo,
    isPendingUpdatedUserInfo,
    isSavingCustomInfo,
    setValue,
    selectedCountry,
    setSelectedCountry,
    MobileOrDesktopContainer,
    isUrlValid,
    auth,
    termsOfUseUrl,
    setTermsOfUseUrl,
    salesPageUrl,
    setSalesPageUrl,
    rtmpEmail,
    setRtmpEmail,
    webUrl,
    setWebUrl,
    iosUrl,
    setIosUrl,
    androidUrl,
    setAndroidUrl,
    formEmbed,
    setFormEmbed,
    myStoreUrl,
    setMyStoreUrl,
    hasMyStore,
    setHasMyStore
  };
};
